import Glide from "@glidejs/glide";
import HeroSlideAnimation from "../../../src/scripts/helpers/hero-slide-animation";

export default class HeroSlider {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.hero-slider'), el => {
			new HeroSlider(el);
		});
	}

	constructor(element) {
		this.element = element;

		// in the Neos backend the element information is rendered in a appended script tag
		// since this script is executed after it's evaluation, we can safely remove it
		// to make the slider work properly
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			Array.from(element.querySelectorAll('script[data-neos-nodedata]'))
				.forEach(script => script.remove());
		}

		const backgroundSliderOptions = {
			peek: 0,
			gap: 0,
			arrows: false,
			rewind: false,
			type: 'carousel',
			startAt: 0,
			perView: 1,
			autoplay: isNeosBackend ? false : 11000,
		};
		const contentSliderOptions = {
			...backgroundSliderOptions,
			autoheight: true,
			autoplay: false,
			swipeThreshold: false,
			dragThreshold: false
		};

		this.backgroundElement = this.element.querySelector('.hero-slider__background-slider');
		this.contentElement = this.element.querySelector('.hero-slider__content-slider');

		this.contentSlider = new Glide(this.contentElement, contentSliderOptions);
		this.backgroundSlider = new Glide(this.backgroundElement, backgroundSliderOptions);

		this.createBullets(this.backgroundElement);
		this.contentSlider.mount();
		this.backgroundSlider.mount();

		this.backgroundSlider
			.on('run', (e) => {
				this.contentSlider.go(e.direction !== '=' ? e.direction : '=' + e.steps);
			});

		new HeroSlideAnimation(this.element, this.contentElement);
	}

	createBullets(slider) {
		let bulletCount = slider.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length;
		let bulletWrapper = slider.querySelector('.glide__bullets');

		if (bulletCount > 1) {
			if (bulletWrapper) {
				for (let index = 0; index < bulletCount; index++) {
					const button = document.createElement('button');
					button.className = 'glide__bullet';
					button.setAttribute("data-glide-dir", '=' + index);

					button.addEventListener('click', () => {
						this.backgroundSlider.go('=' + index);
						this.contentSlider.go('=' + index);
					})
					button.addEventListener('touchstart', () => {
						this.contentSlider.go('=' + index);
						this.backgroundSlider.go('=' + index);
					});

					bulletWrapper.appendChild(button);
				}
			}
		} else {
			if (bulletWrapper) {
				bulletWrapper.remove();
			}
		}
	}
}
